
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.11 6.152c.562.586.89 1.368.89 2.198v13.525C18 23.633 16.64 25 15 25H3c-1.688 0-3-1.367-3-3.125V3.125C0 1.416 1.313 0 3 0h6.984c.797 0 1.547.342 2.11.928l5.015 5.224zM10.5 1.71v5.322c0 .44.328.782.75.782h5.11a1.24 1.24 0 00-.329-.586L11.063 2.05a1.169 1.169 0 00-.563-.342zm6 20.166v-12.5h-5.25C9.984 9.375 9 8.35 9 7.031V1.563H3c-.844 0-1.5.732-1.5 1.562v18.75c0 .879.656 1.563 1.5 1.563h12c.797 0 1.5-.684 1.5-1.563zM9.469 14.16c.328.586.75 1.123 1.219 1.563.562-.098 1.687-.293 2.437-.293 1.031 0 1.875.879 1.875 1.904s-.797 1.855-1.828 1.855c-.985 0-2.39-.878-2.953-1.27-1.031.245-1.922.49-2.719.831-.656 1.172-1.219 2.05-1.5 2.441-.328.44-.844.684-1.36.684-.937 0-1.64-.732-1.64-1.709 0-.488.14-.928.469-1.27.656-.683 1.547-1.269 2.625-1.806.468-.928.89-1.905 1.218-2.832-.656-1.71-.656-3.125-.656-3.125 0-.977.75-1.758 1.64-1.758.938 0 1.688.781 1.688 1.758 0 .244-.046 1.465-.515 3.027zm-4.547 6.201c.187-.293.562-.83 1.031-1.66-.562.342-1.125.733-1.547 1.22-.047.05-.093.099-.093.196 0 .39.421.488.609.244zm3.375-9.57c-.188 0-.328.146-.328.342 0 .049 0 .976.375 2.1.094-.391.281-1.368.281-2.1 0-.195-.14-.342-.328-.342zM7.5 17.236c.75-.244 1.5-.44 2.203-.634-.515-.489-.937-1.026-1.219-1.563-.328.781-.656 1.563-.984 2.197zm5.625-.39c-.563 0-1.781.195-1.828.195.469.293 1.453.781 1.875.781.281 0 .469-.195.469-.44 0-.341-.235-.536-.516-.536z","fill":"#76bc1e"}})])
          )
        }
      }
    